module.exports = __webpack_public_path__ + "media/images/attention-079fa8d18b0a7fd1eea857d6ef70449c.svg";